import { BACKEND_PRIVATE } from './base'
import get from 'lodash/get'

export async function createWallet(wallet: any) {
  const response = await BACKEND_PRIVATE.post('/me/cloud-wallets/create', { payload: wallet })
  return get(response, 'data.result')
}

export async function removeWallet({ address, key }: { address: string; key?: string }) {
  return BACKEND_PRIVATE.delete('/me/cloud-wallets/remove', { data: { payload: { address, key } } })
}

export async function setDefaultWallet(address: string) {
  const response = await BACKEND_PRIVATE.post('/me/cloud-wallets/default', { payload: { address } })
  return get(response, 'data.result')
}

export async function signWallet(payload: any) {
  return BACKEND_PRIVATE.post('/me/cloud-wallets/sign', { payload })
}

export async function renameWallet(payload: any) {
  return BACKEND_PRIVATE.post('/me/cloud-wallets/rename', { payload })
}
